import { FC, createContext, useContext, useState } from 'react';

import { NonStructuredAcademicOfferStatus } from '../types';

export interface AcademicOfferWizardContextState {
  ceAcademicOfferId: number | null;
  setNonStructuredAcademicOfferId: (id: number) => void;
  offerStatus: NonStructuredAcademicOfferStatus | null;
  setOfferStatus: (status: NonStructuredAcademicOfferStatus) => void;
}

const contextDefaultValues: AcademicOfferWizardContextState = {
  ceAcademicOfferId: null,
  setNonStructuredAcademicOfferId: () => {
    throw new Error(
      'You must implement an AcademicOfferWizardProvider setNonStructuredAcademicOfferId handler',
    );
  },
  offerStatus: null,
  setOfferStatus: () => {
    throw new Error(
      'You must implement an AcademicOfferWizardProvider setOfferStatus handler',
    );
  },
};

export const AcademicOfferWizardContext = createContext<AcademicOfferWizardContextState>(
  contextDefaultValues,
);

export function useAcademicOfferWizard() {
  return useContext(AcademicOfferWizardContext);
}

interface AcademicOfferWizardProviderProps {
  initialOfferId?: number | null;
}

export const AcademicOfferWizardProvider: FC<AcademicOfferWizardProviderProps> = ({
  children,
  initialOfferId = null,
}) => {
  const [ceAcademicOfferId, setNonStructuredAcademicOfferId] = useState<
    number | null
  >(initialOfferId);
  const [
    offerStatus,
    setOfferStatus,
  ] = useState<NonStructuredAcademicOfferStatus | null>(null);

  return (
    <AcademicOfferWizardContext.Provider
      value={{
        ceAcademicOfferId,
        setNonStructuredAcademicOfferId,
        offerStatus,
        setOfferStatus,
      }}
    >
      {children}
    </AcademicOfferWizardContext.Provider>
  );
};
